import * as firebase from "firebase/app";
import "firebase/auth";
import * as firebaseObj from 'firebase'
import {CUSTOM_BUCKET_URL} from "../data/application.properties";

const firebaseConfig = require('../data/application.properties').firebaseConfig;
const app = firebase.initializeApp(firebaseConfig);
const storage = app.storage(CUSTOM_BUCKET_URL)
const projectId = firebaseConfig.projectId;
const CUSTOM_BUCKET_CONFIGURATION_URL = projectId+"-configuration";
const storage_configuration = app.storage(CUSTOM_BUCKET_CONFIGURATION_URL)
export default app;
export { firebaseObj, storage, storage_configuration };